// extracted by mini-css-extract-plugin
export var lg = "_49-4";
export var md = "_49-3";
export var sm = "_49-2";
export var xs = "_49-1";
export var xxs = "_49-0";